import { trackStructuredEvent } from 'js/helpers/google-tag-manager';

export const trackDownloadApp = () => {
  return trackStructuredEvent({
    category: 'loyalty_landing_page',
    action: 'click',
    label: 'download_app',
  });
};
